<template>
    <div class="flex h-screen min-w-[1280px] flex-col">
        <PtHeader class="shrink-0" :service="service">
            <template #logo>
                <LogoEureka />
            </template>
            <HeaderMenu />
            <template #userPackageType>
                <UserPackageType/>
            </template>
        </PtHeader>
        <div class="flex-1">
            <router-view></router-view>
        </div>
    </div>
</template>
<script setup lang="ts">
import { PtHeader } from 'patsnap-biz';
import { headerService as service } from './services/header-service';
import { HeaderMenu, UserPackageType } from '@eureka/header-menu-3';
import LogoEureka from '@eureka/logo-eureka';
</script>
